export default "__VITE_ASSET___yapNnXF__"